module.exports = __webpack_public_path__ + "static/service-icon-b5eb4271c213382a344172acbd123b81.png";